export const getElem = (elem) => {
  return document.querySelectorAll(`.${elem}`);
};
